import React, { useState } from 'react'
import Select from "react-select"
import moment from "moment"
import { Checkbox, DatePicker, Dropdown, Menu } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import Receive from '../reusable/receive'
import Modal from '../reusable/modal'

import { usePet, useQuery, normalize, stringifyDate, useToggle, server, useListData } from '../../modules'

const EndofDay = ({ toggle, visible, ranges, shift }) => {
    const [methods, setMethods] = useState([])
    const [waived, setWaived] = useState(0)
    const [cancelled, setCancelled] = useState(0)
    const [discounts, setDiscounted] = useState(0)
    const [shelved, setShelved] = useState([])
    const [open, setOpen] = useState([])

    const [{ loading: eLoading, error: eError }] = usePet('earnings',
        ranges ?
            {
                from: ranges[0]?._d ?? null,
                to: ranges[1]?._d ?? null
            }
            : {}
        , { notify: true, callback: ({ data }) => setMethods(data) })

    const [{ loading: vLoading, error: vError }] = usePet('cancelled',
        ranges ?
            {
                from: ranges[0]?._d ?? null,
                to: ranges[1]?._d ?? null
            }
            : {}
        , { notify: true, callback: ({ data }) => setCancelled(data) })

    const [{ loading: wLoading, error: wError }] = usePet('waived',
        ranges ?
            {
                from: ranges[0]?._d ?? null,
                to: ranges[1]?._d ?? null
            }
            : {}
        , { notify: true, callback: ({ data }) => setWaived(data) })

    const [{ loading: dLoading, error: dError }] = usePet('discounted',
        ranges ?
            {
                from: ranges[0]?._d ?? null,
                to: ranges[1]?._d ?? null
            }
            : {}
        , { notify: true, callback: ({ data }) => setDiscounted(data) })
        
    const [{ loading: shLoading, error: shError }] = usePet('shelved',
        ranges ?
            {
                from: ranges[0]?._d ?? null,
                to: ranges[1]?._d ?? null
            }
            : {}
        , { notify: true, callback: ({ data }) => setShelved(data) })    
        
    const [{ loading: oLoading, error: oError }] = usePet('openBillsByWaiter',
        ranges ?
            {
                from: ranges[0]?._d ?? null,
                to: ranges[1]?._d ?? null
            }
            : {}
        , { notify: true, callback: ({ data }) => setOpen(data) })        

    return (
        <Modal
            w={ 450 }
            centered={ false }
            title={ !shift?.end ? 'End of Day' : 'General Report' }
            toggle={toggle}
            visible={visible}>
            {
                shift ?
                <>
                    <h3>Cashier: {shift?.user?.name}</h3>
                    <h3>From: {stringifyDate(shift?.date)}</h3>
                    {shift?.end && <h3>To: {stringifyDate(shift?.end)}</h3>}
                </>
                :
                <>
                    {ranges[0]?._d && <h3>From: {stringifyDate(ranges[0]?._d)}</h3>}
                    {ranges[1]?._d && <h3>To: {stringifyDate(ranges[1]?._d)}</h3>}
                </>
            }
            <hr />  
            <h1 className="font-semibold text-lg mt-2">Earnings</h1>
            <Receive
                error={eError}
                loading={eLoading}
                progress>
                {
                    methods.map(method =>
                        <h3>{method._id} {normalize(method.total)}</h3>
                    )
                }
                <h3 className="font-bold mb-4">Total earnings { methods.reduce((total, method) => total + method.total, 0)}</h3>
            </Receive>
            <hr />
            <h1 className="font-semibold text-lg mt-2">Discounts</h1>
            <Receive
                error={dError}
                loading={dLoading}
                progress>
                <h3 className="font-bold mb-4">Total discounts given { discounts }</h3>
            </Receive>
            <hr />
            <h1 className="font-semibold text-lg mt-2">Cancelled Items</h1>
            <Receive
                error={dError}
                loading={dLoading}
                progress>
                <h3 className="font-bold mb-0">Number of items cancelled { cancelled?.count ?? 0 }</h3>
                <h3 className="font-bold mb-4">Amount cancelled { cancelled?.amount ?? 0 }</h3>
            </Receive>
            <hr />
            <h1 className="font-semibold text-lg mt-2">Waived</h1>
            <Receive
                error={wError}
                loading={wLoading}
                progress>
                <h3 className="font-bold mb-4">Total waived { waived }</h3>
            </Receive>
            <Receive
                error={shError}
                loading={shLoading}
                progress>
                {
                    shelved.length > 0 ?
                        <>
                            <hr />
                            <h1 className="font-semibold text-lg mt-2">Shelved Bills</h1>
                            {
                                shelved.map(rec =>
                                    <h3>{rec.owner} {normalize(rec.total)} ({ stringifyDate(rec.date, true) })</h3>
                                )
                            }
                            <h3 className="font-bold mb-4">Total shelved { shelved.reduce((total, bill) => total + bill.total, 0)}</h3>
                        </>
                        : null
                }
            </Receive>
            <div className="text-right">
                <button onClick={toggle} className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg mr-4">Close</button>
                <button className="text-white hisani-btn-green-light mt-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Print</button>
            </div>
        </Modal>

    )
}

export default EndofDay